import { first } from 'lodash';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useMemoDetailsQuery } from '@/modules/memos/graphql/MemoDetails.generated';
import { getNodes } from '@/utils/graphqlUtils';

export function useMemoDetailsData(memoId: string) {
  const { createErrorFeedback } = useFeedback();

  const { data, loading, refetch } = useMemoDetailsQuery({
    fetchPolicy: 'cache-and-network',
    variables: { memoId },
    onError: createErrorFeedback(
      `We couldn't load this memo. Please refresh and try again.`
    ),
  });

  const memo = first(getNodes(data?.memos)) ?? null;

  return {
    data,
    loading,
    memo,
    refetch,
  };
}
